import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { throwError } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

import { Globals } from '@core/globals';
import { ButtonComponent } from '@atoms/button/button.component';
import { CheckboxComponent } from '@atoms/checkbox/checkbox.component';
import { FormComponent } from '@atoms/form/form.component';
import { FormInputsComponent } from '@atoms/form/form-inputs/form-inputs.component';
import { FormTitleComponent } from '@atoms/form/form-title/form-title.component';
import { FormSectionComponent } from '@atoms/form/form-section/form-section.component';
import { GridComponent } from '@atoms/grid/grid.component';
import { InputComponent } from '@atoms/input/input.component';
import { LinkComponent } from '@atoms/link/link.component';
import { ParagraphComponent } from '@atoms/paragraph/paragraph.component';
import { PhoneInputComponent } from '@atoms/phone-input/phone-input.component';
import { CarInfoCardComponent } from '@molecules/car-info-card/car-info-card.component';
import { ContactInformationsComponent } from '@molecules/contact-informations/contact-informations.component';
import { FormThanksMessageComponent } from '@molecules/form-thanks-message/form-thanks-message.component';
import { ModalMainComponent } from '@molecules/modal/modal-main/modal-main.component';
import { ModalMainContentComponent } from '@molecules/modal/modal-main-content/modal-main-content.component';
import { ModalHeaderComponent } from '@molecules/modal/modal-header/modal-header.component';
import { ModalTitleComponent } from '@molecules/modal/modal-title/modal-title.component';
import { GlobalsService } from '@services/globals.service';
import { ModalSidebarComponent } from '@molecules/modal/modal-sidebar/modal-sidebar.component';
import { CarInfoService } from '@services/car-info.service';
import { CarItem } from '@models/car.model';
import { GtmService } from '@services/gtm.service';

@Component({
  selector: 'app-car-info-modal',
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    ButtonComponent,
    CheckboxComponent,
    FormComponent,
    FormInputsComponent,
    FormTitleComponent,
    FormSectionComponent,
    GridComponent,
    InputComponent,
    LinkComponent,
    ParagraphComponent,
    PhoneInputComponent,
    CarInfoCardComponent,
    ContactInformationsComponent,
    FormThanksMessageComponent,
    ModalMainComponent,
    ModalMainContentComponent,
    ModalHeaderComponent,
    ModalTitleComponent,
    ModalSidebarComponent,
  ],
  providers: [DatePipe],
  templateUrl: './car-info-modal.component.html',
  styleUrl: './car-info-modal.component.scss',
})
export class CarInfoModalComponent implements OnInit {
  private fb = inject(FormBuilder);
  private destroyRef = inject(DestroyRef);
  public globals = inject(Globals);
  private globalsService = inject(GlobalsService);
  private carInfoService = inject(CarInfoService);
  private datePipe = inject(DatePipe);
  private gtmService = inject(GtmService);
  @Input() data?: { car: CarItem };
  public form = this.fb.nonNullable.group({
    name: ['', { nonNullable: true, validators: [Validators.required] }],
    email: ['', { nonNullable: true, validators: [Validators.required, Validators.email] }],
    phone: ['', { nonNullable: true, validators: [Validators.required] }],
    phoneCode: ['+420', [Validators.required]],
    // date: ['', { nonNullable: true, validators: [Validators.required] }],
    // time: ['', { nonNullable: true, validators: [Validators.required] }],
    marketingAgree: [false, { nonNullable: true, validators: [] }],
  });
  public timeOptions: string[] = [];
  public step: number = 1;
  private userIp: string = '';

  send(): void {
    if (this.form.invalid) return;
    const formData = this.form.getRawValue();
    const callBackFormData = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      message: 'mototechna.cz',
      ip: this.userIp,
      marketingAgree: formData.marketingAgree,
    };
    this.carInfoService
      .sendForm(this.data!.car.aaaid, callBackFormData)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.form.reset();
          this.form.markAsUntouched();
          this.step = 2;

          const dataLayer = {
            event: 'page_view',
            pageURL: '/' + this.globals.language() + '/podekovani-zajem-o-vuz',
            pageType: 'Purchase-10',
            pageTitle: 'Poděkování zájem na vůz',
          };
          this.gtmService.pushGtm(dataLayer);
        },
        error: (error) => {
          throwError(() => 'Something went wrong:' + error);
        },
      });
  }

  ngOnInit(): void {
    this.timeOptions = this.globalsService.createTimeOptions();
    const dataLayer = {
      event: 'page_view',
      pageURL: '/' + this.globals.language() + '/formular-zajem-o-vuz',
      pageType: 'Form-10',
      pageTitle: 'Formulář zájem na vůz',
    };
    this.gtmService.pushGtm(dataLayer);
    this.carInfoService
      .getUserIp()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (response) => {
          this.userIp = response.ip;
        },
        error: () => {
          this.userIp = '108.121.121.211'; // Error set placeholder
        },
      });
  }
}
